<template>
    <div class="container_test_grid_name_level">
        
            <div class="item_test_in_1">
                
                <p align="left" class="text-white  text_size_header_text text-start font_text_ariblk">Бизнес-план</p>
                
            </div>
            
        <div class="item_test_in_2">
            <span class="text_size_header_text_2_name_level font_text_ariblk">{{ data_load }}</span>
            <!-- <span class="text_size_header_text_2_name_level font_text_ariblk">01.01.2024 - 28.06.2024</span> -->
        </div>
    </div>
    <!-- <div class="item_test">
        <p class="text-white text_size_header_text text-start font_text_ariblk">Кронштадт <span class="text_size_header_text_2 font_text_ariblk">01.01.24 - 01.03.24</span></p>
    </div> -->
</template>

<script setup>
    const props = defineProps({
        data_load: {
            type: String,
        }
    })
</script>

<style scoped>

@media screen and (max-width: 1400px) {
	/* html{ 
		font-size: 8px;
	} */
	.text_size_header_text {
        font-size: 20px;
		/* font-size: 24px; */
    }
	.text_size_header_text_2_name_level {
        font-size: 15px;
		/* font-size: 24px; */
    }
}
</style>